import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userCustomerApi from "../api/userCustomerApi";
// create slice

const name = "userCustomer";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const userCustomerActions = { ...slice.actions, ...extraActions };
export const userCustomerReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    userCustomers: [],
    totalCount: 0,
  };
}

function createExtraActions() {
  return {
    getAll: getAll(),
  };

  function getAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async (params) => await userCustomerApi.getAll(params)
    );
  }
}

function createExtraReducers() {
  return {
    ...getAll(),
  };

  function getAll() {
    const { pending, fulfilled, rejected } = extraActions.getAll;
    return {
      [pending]: (state) => {
        // state.userCustomers = { loading: true };
        state.userCustomers = [];
      },
      [fulfilled]: (state, action) => {
        state.userCustomers = action.payload?.results;
        state.totalCount = action.payload?.totalResults;
      },
      [rejected]: (state, action) => {
        // state.userCustomers = { error: action.error };
        state.userCustomers = [];
      },
    };
  }
}
